import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GDAccountNumberCell from 'Components/GDTable/GDAccountNumberCell/GDAccountNumberCell';
import GDDateCell from 'Components/GDTable/GDDateCell';
import GDCurrencyCodeCell from 'Components/GDTable/GDCurrencyCodeCell';
import CardType from 'Components/CardType';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import InformationBubble from 'Components/information-bubble/InformationBubble';
import { getCaseLandingData, getMerchantDetails, getBankDetails, fetchAuthDetails} from 'Apis/caseManagerAPI.js';
import { getUrlSearchParamValue } from 'Utils/urlUtils.js';
import { numberWithCommas } from 'Utils/formatting.js';
import AlertIcon from 'Components/icons/AlertIcon';
import AccountIcon from 'Assets/img/accounting-data.svg';
import MerchantIcon from 'Assets/img/merchant-overview.svg';
import BankIcon from 'Assets/img/banking-information.svg';
import SchemeIcon from 'Assets/img/scheme-data.svg';
import TransactionIcon from 'Assets/img/transaction-overview.svg';
import DisputeIcon from 'Assets/img/dispute-overview.svg';
import { customFormatclass, customClassCurrency } from 'Components/GDTable/GDCustomFormat/GDCustomFormat';
import { Row, Col } from 'antd';
import GDColorCodedCell from '../GDTable/GDColorCodedCell/GDColorCodedCell';
import { fetchTransactionDetails, fetchAccountingDetails} from 'Apis/caseDataAPI';
import AccountingDataPane  from './components/AccountingData/AccountingDataPane';


import './ExpandedOverviewPane.scss';


class ExpandedOverviewPane extends Component {
  constructor(props) {
    super(props);
    this.references = [];
    this.divHeightArray = [];
    this.state = {
      isLoading: true,
      dataErr: true,
      caseDetails: {},
      accountingDetailsNew: [],
      isArchival: getUrlSearchParamValue(this.props.location.search, 'isArchival'),
    };
    this.getCaseDetails = this.getCaseDetails.bind(this);
    this.scrollToRef = this.scrollToRef.bind(this);
    this.getAccountingData = this.getAccountingData.bind(this);
    this.getIsLoadingStatus = this.getIsLoadingStatus.bind(this);
    this.fetchCaseMerchantDetails = this.fetchCaseMerchantDetails.bind(this);
    this.fetchAccountingDetails = this.fetchAccountingLedegerDetails.bind(this);
    this.fetchCaseBankDetails = this.fetchCaseBankDetails.bind(this);
    this.fetchCaseAuthDetails = this.fetchCaseAuthDetails.bind(this);
    this.fetchCaseTransactionDetails = this.fetchCaseTransactionDetails.bind(this);
    this.getCardBrandCode = this.getCardBrandCode.bind(this);
  }

  componentWillMount() {
    this.getCaseDetails(this.props.match.params.caseNumber);
  }

  scrollToRef = (key) => {
    const keyArray =  this.references.map(item => item.id);
    if (this.references && this.references.length !== 0) {
      let reference = this.references.filter(item => item.getAttribute('id') === key)
      window.scrollTo(0, reference[0].offsetTop);
      for (let i = 0; i < this.references.length; i++) {
        this.divHeightArray = this.divHeightArray.concat(this.references[i].offsetHeight);
      } 
    }
  }


  componentDidUpdate(prevProps) {
    const key = getUrlSearchParamValue(this.props.location.search, 'key');
    this.scrollToRef(key);
    }

  getCaseDetails(caseNumber) {
    getCaseLandingData(caseNumber,this.state.isArchival).then((apiResponse) => {
      this.setState({
        isMerchantDetailsLoading: true,
        isBankDetailsLoading: true,
        isActionPagesLoading: true,
        isAccountDataLoading: true,
        isTransactionDetailsLoading: true,
        isAuthDetailLoading: true,
      });

      this.setState({
        caseDetails: Object.assign(this.renameObjectKeys(1, apiResponse.data.caseDetail),
          this.renameObjectKeys(2, apiResponse.data.caseStageDetail)),
        isLoading: false,
        dataErr: false,
      });
      /**
       * Fetching merhcnat,account and bank details
       */
      this.fetchCaseMerchantDetails(caseNumber, apiResponse);
      this.fetchAccountingDetails(caseNumber);
      this.fetchCaseBankDetails(apiResponse);
      this.fetchCaseAuthDetails(caseNumber);
      this.fetchCaseTransactionDetails(caseNumber);
    }).catch((error) => {
      this.setState({ dataErr: true, isLoading: false });
      console.log('Error Occured while fetching unmatched case details', error);
    });
  }

  /**
   * This method is responsible for fetching bank details by casenumber
   * @param {*} apiResponse 
   */
  fetchCaseBankDetails(apiResponse) {
    const acquirerNames = ['MXP', 'EMD'];
    if (apiResponse.data.caseDetail.caseDetail_cardBrandCode && apiResponse.data.caseDetail.caseDetail_acquirerName && (apiResponse.data.caseDetail.caseDetail_cardBrandCode === 'VI' ||
    apiResponse.data.caseDetail.caseDetail_cardBrandCode === 'MC' || acquirerNames.includes(apiResponse.data.caseDetail.caseDetail_acquirerName))) {
      const acquirerAccessCode = apiResponse.data.caseDetail.caseDetail_acquirerName
       ? apiResponse.data.caseDetail.caseDetail_acquirerName
       : undefined;
      let cardBrandCode = this.getCardBrandCode(acquirerAccessCode,apiResponse.data.caseDetail.caseDetail_cardBrandCode);
      let disputeStageId = apiResponse.data.caseStageDetail.caseStageDetail_disputeStageId ? apiResponse.data.caseStageDetail.caseStageDetail_disputeStageId : apiResponse.data.caseStageDetail.disputeStageId ? apiResponse.data.caseStageDetail.disputeStageId : undefined;
      getBankDetails(cardBrandCode, apiResponse.data.caseDetail.caseDetail_issuerBinIca,disputeStageId,this.state.isArchival).then((bankdetails) => {
        if (bankdetails.data) {
          this.setState((prevState, props) => {
            return {
              caseDetails: Object.assign(this.renameObjectKeys(6, bankdetails.data), Object.assign({}, prevState.caseDetails)),
              isBankDetailsLoading: false,
            };
          });
        }
        else {
          this.setState({ isBankDetailsLoading: false });
        }
      }).catch((error) => {
        this.setState({
          isLoading: false,
          isBankDetailsLoading: false,
        });
        console.log('Error Occured while fetching Bank details', error);
      });
    }
    else {
      this.setState({ isBankDetailsLoading: false });
    }
  }

  getCardBrandCode(acquirerCode,cardBrandCode) {
    switch(acquirerCode){
        case "MXP":
          return "PR";
        case "EMD":
          return "EV";
        default:
          return cardBrandCode;
     }
  }
  /**
    * This method is responsible for fetching account details by casenumber
    * @param {*} apiResponse 
    */

  fetchAccountingLedegerDetails(caseNumber) {
    fetchAccountingDetails(caseNumber,this.state.isArchival).then((accountDetail) => {
      if (accountDetail.data) {
        this.setState({
          accountingDetailsNew: accountDetail.data,
          isAccountDataLoading: false
        });
      }
      else {
        this.setState({ isAccountDataLoading: false });
      }
    }).catch((error) => {
      this.setState({
        isLoading: false,
        isAccountDataLoading: false,
      });
      console.log('Error Occured while fetching account details', error);
    });
  }
  /**
    * This method is responsible for fetching merchant details by casenumber
    * @param {*} apiResponse 
    */
  fetchCaseMerchantDetails(caseNumber, apiResponse) {
    getMerchantDetails(caseNumber, apiResponse.data.caseStageDetail.caseStageDetail_disputeStageId,this.state.isArchival).then((merchantDetail) => {
      if (merchantDetail.data) {
        this.setState((prevState, props) => {
          return {
            caseDetails: Object.assign(this.renameObjectKeys(5, merchantDetail.data), Object.assign(prevState.caseDetails)),
            isMerchantDetailsLoading: false,
          };
        });
      }
      else {
        this.setState({ isMerchantDetailsLoading: false });
      }
    }).catch((error) => {
      this.setState({
        isLoading: false,
        isMerchantDetailsLoading: false,
      });
      console.log('Error Occured while fetching Merchant details', error);
    });
  }

  fetchCaseAuthDetails(caseNumber) {
    fetchAuthDetails(caseNumber,this.state.isArchival).then((authDetail) => {
      if (authDetail.data) {
        this.setState((prevState, props) => {
          return {
            caseDetails: Object.assign(this.renameObjectKeys(4, authDetail.data), Object.assign(prevState.caseDetails)),
            isAuthDetailLoading: false,
          };
        });
      }
      else {
        this.setState({ isAuthDetailLoading: false });
      }
    }).catch((error) => {
      this.setState({
        isLoading: false,
        isAuthDetailLoading: false,
      });
      console.log('Error Occured while fetching authorization details', error);
    });
  }

  fetchCaseTransactionDetails(caseNumber) {
    fetchTransactionDetails(caseNumber,this.state.isArchival).then((transactionDetails) => {
      if (transactionDetails.data) {
        this.setState((prevState, props) => {
          return {
            caseDetails: Object.assign(this.renameObjectKeys(3, transactionDetails.data), Object.assign({}, prevState.caseDetails)),
            isTransactionDetailsLoading: false,
          };
        });
      }
      else {
        this.setState({ isTransactionDetailsLoading: false });
      }
    }).catch((error) => {
      this.setState({
        isLoading: false,
        isTransactionDetailsLoading: false,
      });
      console.log('Error Occured while fetching account details', error);
    });
  }

  getIsLoadingStatus() {
    const { isLoading, isMerchantDetailsLoading,
      isBankDetailsLoading, isAccountDataLoading, isTransactionDetailsLoading, isAuthDetailLoading } = this.state;
    return (isLoading || isMerchantDetailsLoading ||
      isBankDetailsLoading, isAccountDataLoading , isTransactionDetailsLoading, isAuthDetailLoading);
  }

  getItemData = (item, index) => {
    const data = this.state.caseDetails;
    const key = `${index} ${item.columnKey}`;
    if (data[`${item.columnKey}`] && data[`${item.columnKey}`] !== '' && data[`${item.columnKey}`] !== 'null') {
      if (item.displayType === 'DATE') {
        return (
          <span className="date">
            <GDDateCell
              key={`${item.columnKey}`}
              date={data[`${item.columnKey}`]}
              dateFormat={this.props.preferences.dateFormat}
              timeFormat={this.props.preferences.timeFormat}
            />
          </span>
        );
      }
      if (item.displayType === 'MERCHANTNUMBER') {
        return (
          <div className="gd-color-coded-cell">
            <GDColorCodedCell
              key={key}
              content={data[item.columnKey]}
            />
          </div>
        );
      }
      if (item.displayType === 'HIERARCHY'){
        let evoHierarchy=(data.caseDetail_acquirerName=='EMD'||data.caseDetail_acquirerName=='EMI');

          return (data.merchantDetail_corporate)
           ?
                    <span>
            {`${data.merchantDetail_corporate}-${data.merchantDetail_region}-${
              data.merchantDetail_principal}-${data.merchantDetail_associate}-${
              data.merchantDetail_chain}`}
          </span>
          :
          evoHierarchy?
            <span>
            {`${data.merchantDetail_group}-${data.merchantDetail_chain}-${
              data.merchantDetail_taxID}`}
          </span>
          :
              <span>
            {`${data.merchantDetail_corporate}-${data.merchantDetail_region}-${
              data.merchantDetail_principal}-${data.merchantDetail_associate}-${
              data.merchantDetail_chain}`}
          </span>
      }
      if (item.displayType === 'LONGSTRING') {
        return <span>{data[`${item.columnKey}`]}</span>;
      }
      if (item.displayType === 'MAILINGADDRESS') {
        return (
          <span>
            {data[`${item.columnKey}`]}

          </span>
        );
      } else {
        return <span>{data[`${item.columnKey}`]}</span>;
      }
    } else if (typeof item.columnKey === 'object') {
      if (item.displayType === 'CARDTYPE_ACCOUNTNUMBER' && data[`${item.columnKey.value2}`]) {
        return (
          <div>
            <div className="card-type">
              <CardType
                abbreviation={data[`${item.columnKey.value1}`]}
                type={data[item.columnKey.value1]}
              />
            </div>
            <div className="overviewpane-account-cell">
              <GDAccountNumberCell
                accountNumber={data[`${item.columnKey.value2}`]}
                isMerchantPortal={this.props.isMerchantUser}
              />
            </div>
          </div>
        );
      } else if (item.displayType === 'DATE_AMOUNT' && data[`${item.columnKey.value1}`] != null) {
        return (
          <div>
            <span className="date-cell">
              <GDDateCell
                key={`${item.columnKey.value1}`}
                date={data[`${item.columnKey.value1}`]}
                dateFormat={this.props.preferences.dateFormat}
                timeFormat={this.props.preferences.timeFormat}
              />
            </span>
            <span className="currency-cell">{this.getCurrencyCell(data[item.columnKey.value2], data[item.columnKey.value3], item.columnKey.value2, item.columnKey.value3)}</span>
          </div>
        );
      } else if (item.displayType === 'STRING_STRING') {
        return (
          <div>
            <span style={{ paddingRight: '30px' }}>{data[`${item.columnKey.value1}`]}</span>
            <span style={{ paddingLeft: '30px' }}>{data[`${item.columnKey.value2}`] ? data[`${item.columnKey.value2}`] : '--'}</span>
          </div>
        );
      } else if (item.displayType === 'ADDRESS') {
        return (
          <div>
            <span>{data[`${item.columnKey.value1}`]}</span>
            <br />
            <span>{data[`${item.columnKey.value2}`]}</span>
          </div>
        );
      }
      if (item.displayType === 'CURRENCY_UNIT') {
        return (
          <span className="currency-cell">{this.getCurrencyCell(data[item.columnKey.value1], data[item.columnKey.value2], item.columnKey.value1, item.columnKey.value2, item.displayType)}</span>
        );
      }
    }
    return <span>--</span>;
  };

  displayIcon = (id) => {
    switch (id) {
      case 1:
        return DisputeIcon;
      case 2:
        return TransactionIcon;
      case 3:
        return MerchantIcon;
      case 4:
        return SchemeIcon;
      case 5:
        return BankIcon;
      case 6:
        return AccountIcon;
      default:
        return null; 
    }
  };

  getCurrencyCell = (amount, currency, columnKey1, columnKey2, displayType,isNormalizedValue) => {
    if (currency !== undefined) {
      const normalizedValue = isNormalizedValue ? amount : amount == 0 ? 0 : (Math.round(amount * 100) / 100).toFixed(2) || '--';
      const normalizedUnits = currency || '';
      let valueClass;
      if (Number.isNaN(Number.parseFloat(amount))) {
        return <span key={`${columnKey1}`}>{normalizedValue}</span>;
      }

      if (!Number.isNaN(Number.parseFloat(normalizedValue)) && Number.parseFloat(normalizedValue) < 0) { valueClass = customFormatclass(customClassCurrency, displayType); }
      return (
        <GDCurrencyCodeCell
        //  key={`${columnKey1}`}
          value={normalizedValue}
          units={normalizedUnits}
          customClass={valueClass}
        />
      );
    } else {
      let valueClass;
      const normalizedValue = amount !== '' ? amount : '--';
      if (!Number.isNaN(Number.parseFloat(normalizedValue)) && Number.parseFloat(normalizedValue) < 0) { valueClass = customFormatclass(customClassCurrency, item.displayType); }
      return (
        <GDCurrencyCodeCell
          key={`${columnKey1}`}
          value={normalizedValue}
          customClass={valueClass}
        />
      );
    }
  };

  getAccountingData = (item) => {
    
    if (item.columnKey === 'settlementCompanyNumber') {
      if(this.state.caseDetails['caseDetail_settlementCompanyNumber'] && this.state.caseDetails['caseDetail_settlementCompanyNumber'].length !== 0){
        return ( 
          <span>
            {this.state.caseDetails['caseDetail_settlementCompanyNumber']}
          </span>
        )
      }else{
        return '--';
      }
      
    } 
    else if (item.columnKey === 'bankId') {
      if(this.state.caseDetails['caseDetail_bankId'] && this.state.caseDetails['caseDetail_bankId'].length!==0){
        return ( 
          <span>
            {this.state.caseDetails['caseDetail_bankId']}
          </span>
        )
      }else{
        return '--';
      }
     
    } 
    else if (item.columnKey === 'transactionType') {
      if(this.state.caseDetails['caseDetail_transactionType'] && this.state.caseDetails['caseDetail_transactionType'].length!==0 ){
        return ( 
          <span>
            {this.state.caseDetails['caseDetail_transactionType'] === 'sales' ? 'Sale': this.state.caseDetails['caseDetail_transactionType']}
          </span>
        )
      }else{
        return '--';
      }
    } 
    
    return <span>--</span>;
  };
 
  getStyle = (index1, index2) => {
    if(!this.props.isMerchantUser)
    { 
   
  switch (index1) {
    case 1:
      return index2 % 3 == 0 && index2 !== 0 ? "no-border" : "show-border";
    case 2:
      return index2 % 4 == 0 && index2 !== 0 ? "no-border" : "show-border";
    case 3:
      return index2 % 2 === 0 && index2 !== 0 ? "no-border" : "show-border";
  }
}
  else
  { 
    switch (index1) {
      case 1:
        return index2 % 9 == 0 && index2 !== 0 ? "no-border" : "show-border";
      case 2:
        return index2 % 22 == 0 && index2 !== 0 ? "no-border" : "show-border";  
  }
}
}
crollToRef = (key) => {
  const keyArray = [3, 5, 6];
  if (this.references && this.references.length !== 0) {
    let reference = this.references.filter(item => item.getAttribute('id') === key)
    window.scrollTo(0, reference[0].offsetTop);
    for (let i = 0; i < 3; i++) {
      this.divHeightArray = this.divHeightArray.concat(this.references[i].offsetHeight);
    }
    for (let i = 0; i < 3; i++) {
      document.getElementById(keyArray[i]).setAttribute("style", `height:${Math.max(...this.divHeightArray)}px`)
    }
    let list = document.getElementById(6);
    if (list.offsetHeight > 350) {
      for (let i = 0; i < 5; i++) {
        if (i <= 1)
          list.getElementsByTagName("li")[i].setAttribute("style", `border-bottom: none`);
        else
          list.getElementsByTagName("li")[i].setAttribute("style", `border-bottom: none`);
      }
    }
  }
}
 
  
  renameObjectKeys(index, obj1) {
    let prepend;
    switch (index) {
      case 1:
        prepend = 'caseDetail_';
        break;
      case 2:
        prepend = 'caseStageDetail_';
        break;
      case 3:
        prepend = 'transactionDetail_';
        break;
      case 4:
        prepend = 'authorizationDetail_';
        break;
      case 5:
        prepend = 'merchantDetail_';
        break;
      case 6:
        prepend = 'bankDetail_';
        break;
      default:
        return;
    }
    if (obj1 == null) { return obj1; }
    Object.keys(obj1).map((key) => {
      const new_key = prepend + key;
      obj1[new_key] = obj1[key];
      delete obj1[key];
    });
    return obj1;
  }
  render() {
    const data = { ...this.state.caseDetails };
    return (
      <React.Fragment>
        {this.getIsLoadingStatus() && <BVLoader20 />}
        <div className="page-wrapper">
          {
            !this.state.dataErr && this.props.displayStructure.map((element, index1) => {
              let authFilteredColumns = this.props.isCitiUser ? element.dataColumns?.filter(item => item.name !== 'Authorized' && item.name !== 'Authorization') : element.dataColumns;
              return (
                <div className={index1 === 2 ? 'expanded-overviewpane add-margin' : 'expanded-overviewpane'} id={element.id} ref={(element) => (this.references[index1] = element)} key={index1}>
                  <div className="expanded-overviewpane-title" id="title">
                    <Row>
                      <Col span={1}><img src={this.displayIcon(element.id)} className="titleIcon" /></Col>
                      <Col span={23}><h2 className="titleContent">{element.title}</h2></Col>
                    </Row>
                  </div>

                  <ul className={element.id === 6 ? 'expanded-overviewpane-list':'expanded-overviewpane-list-not-visible'}>
                    {
                      authFilteredColumns.filter(item => item.displayType!=='TABLE').sort((ele1, ele2) => 
                      {
                        const item1 = ele1 && ele1.name && ele1.name.toLowerCase();
                        const item2 = ele2 && ele2.name && ele2.name.toLowerCase();
                        if (item1 < item2) return -1;
                        if (item1 > item2) return 1;
                        return 0;
                      }).map((item, index2) => {
                        if(element.id === 6){
                          return (
                            <li className={`no-border expanded-overviewpane-list-item`} key={item.name}>
                              <div className="expanded-overviewpane-list-item-wrapper">
                                <span className="expanded-overviewpane-list-item-label">
                                  {item.name} 
                                </span>
                                <span className={item.displayType === 'LONGSTRING' && data[`${item.columnKey}`] && data[`${item.columnKey}`].length > 27 ? 'long-string' : 'overviewpane-list-item-content'}>
                                 {this.getAccountingData(item)}
                                  <span className="reason-code-tooltip">
                                    {
                                      item.displayType == 'RC' && (
                                        <InformationBubble
                                          id={item.descriptionKey}
                                          info
                                        />
                                      )
                                    }
                                  </span>
                                </span>
                              </div>
                            </li>
                          );
                        }
                        
                      })
                    }
                  </ul>
                   {element.id === 6 &&  <AccountingDataPane caseDetails={this.state.caseDetails} accountingDetailsNew= {this.state.accountingDetailsNew} />} 
                  <ul className={element.id === 6 ? 'expanded-overviewpane-list-not-visible':'expanded-overviewpane-list'}>
                    {
                      authFilteredColumns.sort((ele1, ele2) => {
                        const item1 = ele1 && ele1.name && ele1.name.toLowerCase();
                        const item2 = ele2 && ele2.name && ele2.name.toLowerCase();
                        if (item1 < item2) return -1;
                        if (item1 > item2) return 1;
                        return 0;
                      }).map((item, index2) => {
                        if(element.id != 6){
                          return (
                            <li className={item.displayType === 'TABLE' ? "expanded-overviewpane-list-item" : `${this.getStyle(index1 + 1, index2 + 1)} expanded-overviewpane-list-item`} key={item.name}>
                              <div className="expanded-overviewpane-list-item-wrapper">
                                <span className="expanded-overviewpane-list-item-label">
                                  {item.name} 
                                </span>
                                <span className={item.displayType === 'LONGSTRING' && data[`${item.columnKey}`] && data[`${item.columnKey}`].length > 27 ? 'long-string' : 'overviewpane-list-item-content'}>
                                  {element.id === 6 ? this.getAccountingData(item) : this.getItemData(item)}
                                  <span className="reason-code-tooltip">
                                    {
                                      item.displayType == 'RC' && (
                                        <InformationBubble
                                          id={item.descriptionKey}
                                          info
                                        />
                                      )
                                    }
                                  </span>
                                </span>
                              </div>
                            </li>
                          );
                        }
                        
                      })
                    }
                  </ul>
                </div> 
              );
            })
          }
        </div>
      </React.Fragment>
    );
  }
}


ExpandedOverviewPane.defaultProps={
preferences:{},
isMerchantUser:false,
};

export default ExpandedOverviewPane;
